import IconFilms from '../resources/img/icons/films.png'
import IconGames from '../resources/img/icons/games.png'
import IconSports from '../resources/img/icons/sports.png'

const Channels = {
    film: {
        name: 'Films',
        img: IconFilms,
    },
    gaming: {
        name: 'Gaming',
        img: IconGames,
    },
    sport: {
        name: 'Sports',
        img: IconSports,
    },
}

export default Channels
